<div class="container mt-4" dir="rtl">
<h3 class="mb-4 fw-bold text-primary"> 🍳 متن آهنگ</h3>

  <!-- Add user Button -->
  <div class="d-flex justify-content-end mb-3">
    <button class="btn btn-primary" (click)="openModal()">
      افزودن متن آهنگ جدید
    </button>
  </div>

  <!-- 🔍 نوار جستجو -->
  <div class="mb-3">
    <input
      type="text"
      class="form-control shadow-sm"
      placeholder="   جستجوی خواننده یا متن آهنگ..."
      [(ngModel)]="searchText"
      (input)="onSearch()"
    />
  </div>

  <!-- 🟪 نسخه موبایل: نمایش کارتی -->
  <div class="d-block d-md-none">
    <div *ngFor="let item of anyList" class="card mb-3 shadow-sm">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ item.songName }}</h5>
        <h5 class="card-title fw-bold">{{ item.songText }}</h5>
        <h5 class="card-title fw-bold">{{ item.singer }}</h5>

        <div class="mt-2 text-end">
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 🟪 نسخه دسکتاپ: نمایش جدولی -->
  <div class="table-responsive d-none d-md-block">
    <table class="table table-bordered text-end custom-table">
      <thead class="custom-thead">
        <tr>
          <th style="width: 20%;">عنوان آهنگ</th>
          <th style="width: 45%;">متن ترانه</th>
          <th style="width: 17%;">خواننده</th>
          <th style="width: 18%;">عملیات </th>
          <!-- <th style="gap-2: text-align: center;"></th> -->
          <!-- <th style="width: 30%; white-space: nowrap;"></th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredList">

           <td style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <strong>{{ item.songName }}</strong>
          </td>
          <td>
            <span
              class="text-primary"
              style="cursor:pointer;"
              (click)="openDetailModal(item)"
            >
              {{ item.songText | slice:0:100 }}...
            </span>
          </td>

           <td style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <strong>{{ item.singer }}</strong>
          </td>

          <td>
            <!-- دکمه ها در یک div قرار گرفتند و راست چین شدند -->
            <div class="d-flex justify-content-end flex-wrap" style="gap: 0.5rem;">
              <button
                class="btn btn-warning btn-sm"
                (click)="openEditModal(item)"
              >
                ✏️ ویرایش
              </button>
              <button
                class="btn btn-danger btn-sm"
                (click)="delete(item.id)"
              >
                🗑 حذف
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <!-- Modal -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">

    <!-- <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true"> -->
     <div class="modal-dialog modal-lg modal-dialog-centered"> <!-- modal-lg برای عرض بیشتر و modal-dialog-centered برای وسط چین شدن -->
      <div class="modal-content" dir="rtl">
        <div class="modal-header bg-primary text-white"> <!-- هدر با رنگ اصلی و متن سفید -->
         <h5 class="modal-title">{{ anyObj.id ? 'ویرایش مطلب' : 'افزودن مطلب' }}</h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            (click)="closeModal()"
          ></button>
        </div>

        <div class="modal-body p-4">
          <form id="userForm">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label"> نام آهنگ</label>
                <input type="text"
                [(ngModel)]="anyObj.songName"
                 name="songName" class="form-control"
                 placeholder="عنوان ترانه "required/>
              </div>


                <div class="col-md-12">
                <label class="form-label fw-bold">متن ترانه </label>
                <textarea
                  [(ngModel)]="anyObj.songText"
                  name="songText"
                  class="form-control form-control-lg shadow-sm"
                  placeholder="متن آهنگ"
                  rows="6"
                  required
                ></textarea>

              <div class="col-md-6">
                <label class="form-label">خواننده</label>
                <input type="text" [(ngModel)]="anyObj.singer" name="singer" class="form-control" placeholder="خواننده ترانه">
              </div>
            </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
          <button type="button" (click)="onSave()" class="btn btn-success">
            {{ anyObj.id ? 'ذخیره تغییرات' : 'افزودن' }}
          </button>
        </div>
      </div>
    </div>
  </div>


   <!-- 🟦 Modal نمایش متن کامل -->
  <div class="modal fade" #detailModal tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" dir="rtl" style="word-wrap: break-word; overflow-wrap: break-word;">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ detailObj?.songName }}</h5>
          <button class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div
          class="modal-body"
          style="white-space: pre-line; text-align: justify; word-break: break-word;"
        >
          <p class="fs-6">{{ detailObj?.songText }}</p>
        </div>
        

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
        </div>
      </div>
    </div>
  </div>
</div>
